export const iconFontAwesomeHouseholdBed = (
	<i className="fa-solid fa-bed"></i>
);
